export enum ROLE {
  TECHNICAL = 'TECHNICAL',
  USER_DOCTOR = 'USER_DOCTOR',
  ADMIN = 'ADMIN',
  USER = 'USER',
  PATIENT = 'PATIENT',
  DOCTOR = 'DOCTOR',
}
